const apiHttpResponseCodes = {
  Ok: 200,
  TooManyRequests: 429,
  NotFound: 404,
  NotAuthorized: 401,
  Forbidden: 403,
};

export default apiHttpResponseCodes;
